
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Pagination from "@/components/Pagination/index.vue";
import { IStorageLayerDeliveryNoteInfoModel, IStorageModel } from "@/api/types";
import {
  getProblemCustomsPlans,
  editPalnPackages,
  getConfirmPlans,
} from "@/api/inventory-plan";
import {
  InventoryPlans,
  HqPackingList,
  UnpackedProductInfos,
  CustomsPackingSet,
} from "@/model/inventory-plan";
import {
  updateProductQuantity,
  updateCustomsPackingInfo,
} from "@/api/customs-packing";

import { confirmCustomsPacking } from "@/api/inventory-plan";

import ConfirmTable from "./ConfirmTable.vue";
import DeclarationDocumentTable, {
  LoadingPlanListTableRowData,
} from "@/views/components/DeclarationDocumentTable.vue";
import { deepClone } from "@/utils/deepClone";

@Component({
  name: "wareHouseEntryGuideDiagram",
  components: {
    Pagination,
    ConfirmTable,
  },
})
export default class extends Vue {
  @Prop({ required: false, default: "1" }) private confirmType: string;
  @Prop({ required: false, default: "" }) private title: string;
  @Prop({ required: false, default: false }) private show: boolean;
  @Prop({ required: true }) private confirmRow: InventoryPlans;
  @Watch("confirmRow", { deep: true, immediate: true })
  private watchData() {
    this.inventoryPlanId = this.confirmRow.id;
    this.getDetail();
  }
  private open() {
    this.$emit("update:show", true);
  }
  private close() {
    this.$emit("update:show", false);
  }
  private textMap = {
    addStorageColumnRemark: "添加备注",
  };
  private inventoryPlanId: string;
  private listLoading = true;
  private checkedAll = false;
  private inventoryPlans: InventoryPlans = new InventoryPlans();
  private hqPackingList: HqPackingList = new HqPackingList();

  // 查看盘库详情
  private async getDetail() {
    this.listLoading = true;
    const data: any =
      this.confirmType === "1"
        ? await getConfirmPlans(this.inventoryPlanId)
        : await getProblemCustomsPlans(this.inventoryPlanId);
    this.hqPackingList = data;
    this.listLoading = false;
  }

  private gotoPackageManagementPage(id: string) {
    this.$router.push({
      path: `/inbound-management/delivery-note/${this.inventoryPlanId}/packing-list/${id}/package-management`,
    });
  }

  private async handleEditProductNumber(row: UnpackedProductInfos) {
    await updateProductQuantity(row.id, { quantity: row.totalNumberPcs });
    await this.getDetail();
  }

  private async onDialogConfirmed(row: CustomsPackingSet) {
    const writePackingInfoInput = new WritePackingInfoInput(row);
    await editPalnPackages(writePackingInfoInput.id, writePackingInfoInput);
    await this.getDetail();
  }

  private closeDialog() {
    this.show = false;
  }

  private async confirmCustomsPackingList() {
    let selectArr = [];
    let list = deepClone(this.hqPackingList);
    list.forEach((item, index) => {
      const selection: CustomsPackingSet[] = (
        this.$refs.inventoryTable[index] as ConfirmTable
      ).selection;
      selectArr = [...selection, ...selectArr];
    });
    let customsPackingIds = selectArr.map((item) => {
      return item.id;
    });
    await confirmCustomsPacking(this.inventoryPlanId, {
      customsPackingIds,
    });
    this.close()
    this.$emit("confirm");
  }
}

class WritePackingInfoInput {
  id: string;
  grossWeight: number;
  netWeight: number;
  length: number;
  width: number;
  height: number;

  constructor(row: CustomsPackingSet) {
    this.id = row.id;
    this.grossWeight = row.packingWeight.grossWeight;
    this.netWeight = row.packingWeight.netWeight;
    this.length = row.packingVolume.length;
    this.width = row.packingVolume.width;
    this.height = row.packingVolume.height;
  }
}
